<template>
  <div class="widget campaign event">
    <p-progress-linear v-if="vm.isLoading" indeterminate></p-progress-linear>
    <p-form :model="vm.formPayload">
      <!-- Do not provide the contact id in the dynamic form -->
      <!-- We always want to show the contact section and don't want the contact id in the payload -->
      <p-dynamic-form
        v-if="!vm.isLoading && _.isEmpty(vm.error) && !vm.isSubmitted"
        v-model="vm.formPayload"
        :summary.sync="formSummary"
        :json-schema.sync="vm.formPayload.schema"
        :form-definition="vm.formDefinition"
        :group-display-overrides="vm.groupDisplayOverrides"
      ></p-dynamic-form>
    </p-form>
    <p-request-alert
      v-if="_.isSet(vm.error)"
      v-model="vm.error"
      class="mb-3 mt-3"
    ></p-request-alert>
    <p-alert type="success" class="mb-3 mt-3" :value="vm.isSubmitted">
      <div>
        {{ $t('widget.registration.formSentSuccessful') }}
      </div>
      <div>
        {{ $t('widget.registration.emailConfirmation') }}
      </div>
    </p-alert>
    <p-row v-if="!vm.isLoading">
      <p-col v-if="!vm.isSubmitted" justify-end>
        <p-button :disabled="!vm.canSubmitForm" :loading="vm.isSubmitting" @click="vm.submitForm()">
          {{ $t('core.app.send') }}
        </p-button>
      </p-col>
      <p-col v-else justify-start>
        <p-button @click="windowBack">
          {{ $t('core.app.back') }}
        </p-button>
      </p-col>
    </p-row>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import CampaignEventVM from './event.vue.model';

  export default Vue.extend({
    layout: 'layout-widget',
    props: {
      contactId: { default: undefined, type: String },
      definitionId: { default: '149f637e-2d03-47d6-904e-4f799da54615', type: String },
      appSystemKey: { default: 'OM', type: String },
    },
    data: () => ({
      vm: new CampaignEventVM(),
      formSummary: {},
    }),
    computed: {
      // read from widget config
      innerAppSystemKey(): string {
        if (this._.isSet(this.appSystemKey)) {
          return this.appSystemKey;
        }
        if (this.$config.values['widget-dynamicform-appsystemkey']) {
          return this.$config.values['widget-dynamicform-appsystemkey'];
        }
        const queries = this.$routerUtils.getQueryParams();
        return queries.appsystemkey as string;
      },
      innerContactId(): string {
        if (this._.isSet(this.contactId)) {
          return this.contactId;
        }
        if (this.$config.values['widget-dynamicform-contactid']) {
          return this.$config.values['widget-dynamicform-contactid'];
        }
        const queries = this.$routerUtils.getQueryParams();
        return queries.contactid as string;
      },
      innerDefinitionId(): string {
        if (this._.isSet(this.definitionId)) {
          return this.definitionId;
        }
        if (this.$config.values['widget-dynamicform-formid']) {
          return this.$config.values['widget-dynamicform-formid'];
        }
        const queries = this.$routerUtils.getQueryParams();
        return queries.id as string;
      },
    },
    async mounted() {
      this.vm.appSystemKey = this.innerAppSystemKey;
      this.vm.formDefinitionId = this.innerDefinitionId;
      this.vm.contactId = this.innerContactId;
      await this.vm.initialize();
    },
    methods: {
      windowBack() {
        let backFunc = this.$router.back.bind(this.$router);
        if (this._.isSet(window?.history)) {
          backFunc = window.history.back.bind(window.history);
        } else if (typeof (window as any)?.back === 'function') {
          backFunc = (window as any).back.bind(window);
        }
        backFunc();
      },
    },
  });

</script>
